module.exports = __webpack_public_path__ + "static/media/Selfishness.5da94589.png";